import { render, staticRenderFns } from "./QuitaShowData.vue?vue&type=template&id=3169238c"
import script from "./QuitaShowData.vue?vue&type=script&lang=js"
export * from "./QuitaShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports